<template>
  <data-chip
    :text="statusText(status)"
    :color="statusColor(status)"
    :iconLeft="statusIcon(status)"
    :small="small"
  >
  </data-chip>
</template>

<script>
import DataChip from "@/components/_systemwide/DataChip.vue";
export default {
  name: "reports-status-chip",
  components: {
    DataChip,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    statusText(statusId) {
      switch (statusId) {
        case "inProgress":
          return "In Bearbeitung";
        case "inCorrection":
          return "In Korrektur";
        case "toBeReviewed":
          return "Zu prüfen";
        case "rejected":
          return "Abgelehnt";
        case "approved":
          return "Genehmigt";
        case "completed":
          return "Festgeschrieben";
        case "archived":
          return "Archiviert";
        default:
          return "Fehler";
      }
    },
    statusIcon(statusId) {
      switch (statusId) {
        case "inProgress":
        case "inCorrection":
          return "pencil-box-multiple";
        case "toBeReviewed":
          return "check-all";
        case "rejected":
          return "close-circle";
        case "approved":
          return "check-circle";
        case "completed":
          return "archive-check";
        case "archived":
          return "archive-cancel";
        default:
          return "alert";
      }
    },
    statusColor(statusId) {
      switch (statusId) {
        case "inProgress":
        case "inCorrection":
          return "orange";
        case "toBeReviewed":
          return "purple";
        case "rejected":
          return "red";
        case "approved":
        case "completed":
          return "green";
        case "archived":
          return "blue-grey";
        default:
          return "grey";
      }
    },
  },
};
</script>
